import { createContext as t } from "react";
const o = () => t(void 0);
export {
  o as createPlatformContext
};
